import React, { useState } from 'react'
import { Form, FormControl } from 'react-bootstrap'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import SearchLoading from '../../../utils/SearchLoading'
import {BiSearchAlt} from 'react-icons/bi'

const Search = (props) => {
    const [loading, setLoading] = useState('')
    const [search, setSearch] = useState('')
    const [searchBox, setSearchBox] = useState(false)
    const [typingTimeout, setTypingTimeout] = useState(0)
    const [result, setResult] = useState([])
    const {t} = useTranslation();

    const handleSearchBox = (event) => { setSearch(event.target.value) }

    const searchFunction = () => {
        if (typingTimeout) { 
            clearTimeout(typingTimeout) 
            setSearchBox(true)
            setLoading(true)
        }
        setTypingTimeout(setTimeout(function () {
            axios.get("p/search/"+search)
            .then(res => {
                setLoading(false)
                setSearchBox(true)
                setResult(res.data)
            })
            .catch(err => console.log(err))
        }, 2000))
    }

    return (
        <div className="search-container">
            <Form className="d-flex">
                <FormControl
                    type="text"
                    autoComplete="off"
                    placeholder={t("search")}
                    className="navSearchBox mx-2"
                    aria-label="Search"
                    value={search}
                    name="search"
                    onChange={e => handleSearchBox(e)}
                    onKeyUp={searchFunction}
                />
                {/* <BiSearchAlt className='searchIcon' size='1.6em' /> */}
            </Form>
            {
                searchBox ? 
                    <div className='search_box'>
                        <span className='close_searchBox' onClick={e => setSearchBox(false)}>&times;</span>
                        <ul className='search-list'>
                            {loading ?
                                <SearchLoading />  
                            :
                                result.length ? 
                                <>
                                    {result.find(items => items.type === "saloons") &&
                                        <div>
                                            <strong> {t("dashboard_nav_saloons")} : </strong>
                                            {result.filter(items => items.type === "saloons").map(searchItem => (
                                                <li key={searchItem.searchable.id}>
                                                    <Link to={`/saloon/${searchItem.searchable ? searchItem.searchable.id : ''}`}>
                                                    <span> {searchItem.title} </span> 
                                                </Link></li>
                                            ))}
                                        </div>
                                    }
                                    {result.find(items => items.type === "users") &&
                                        <div>
                                            <strong> {t("dashboard_nav_companies")} : </strong>
                                            {result.filter(items => items.type === "users").map(searchItem => (
                                                <li key={searchItem.searchable.id}>
                                                    <Link to={`/company/${searchItem.searchable ? searchItem.searchable.id : ''}`}>
                                                    <span> {searchItem.title} </span> 
                                                </Link></li>
                                            ))}
                                        </div>
                                    }
                                    {result.find(items => items.type === "products") &&
                                        <div>
                                            <strong> {t("dashboard_nav_products")} : </strong>
                                            {result.filter(items => items.type === "products").map(searchItem => (
                                                <li key={searchItem.searchable.id}>
                                                    <Link to={`/product/${searchItem.searchable ? searchItem.searchable.id : ''}`}>
                                                    <span> {searchItem.title} </span> 
                                                </Link></li>
                                            ))}
                                        </div>
                                    }
                                </>
                             : <li className='text-center'>{t("No results found")}</li>
                            }
                        </ul>
                    </div>
                : ''
            }
            
        </div>
    )
}

export default Search
